{
  "hr.nav.group": "HR",
  "hr.nav.myHr": "My HR",
  "hr.nav.people": "People",
  "hr.people.title": "People",
  "hr.people.subtitle": "Everyone on the team, their employment records, and who reports to whom.",
  "hr.tabs.label": "People sections",
  "hr.tabs.directory": "Directory",
  "hr.tabs.orgChart": "Org chart",
  "hr.record.open": "Open a record",
  "hr.status.active": "Active",
  "hr.status.upcoming": "Joining soon",
  "hr.status.former": "Former",
  "hr.status.no_record": "No record",
  "hr.contract.full_time": "Full time",
  "hr.contract.part_time": "Part time",
  "hr.contract.freelance": "Freelance",
  "hr.workMode.office": "Office",
  "hr.workMode.hybrid": "Hybrid",
  "hr.workMode.remote": "Remote",
  "hr.hoursPolicy.flexible": "Flexible hours",
  "hr.hoursPolicy.flexibleHint": "Any hours that add up to the workday.",
  "hr.hoursPolicy.fixed": "Fixed hours",
  "hr.hoursPolicy.fixedHint": "A set start and end time.",
  "hr.documentKind.contract": "Employment contract",
  "hr.documentKind.id_card": "ID card",
  "hr.documentKind.cv": "CV",
  "hr.documentKind.certificate": "Certificate",
  "hr.documentKind.medical": "Medical",
  "hr.documentKind.other": "Other",
  "hr.jobKind.hired": "Joined the team",
  "hr.jobKind.promoted": "Promotion",
  "hr.jobKind.promotedHint": "A new title, and maybe a new department.",
  "hr.jobKind.transferred": "Transfer",
  "hr.jobKind.transferredHint": "A move to another department.",
  "hr.jobKind.manager_changed": "New manager",
  "hr.jobKind.manager_changedHint": "They now report to someone else.",
  "hr.jobKind.contract_changed": "New contract",
  "hr.jobKind.contract_changedHint": "Full time, part time or freelance.",
  "hr.jobKind.role_changed": "Access role changed",
  "hr.jobKind.left": "Left the team",
  "hr.value.none": "Not set",
  "hr.value.standardDay": "Standard workday",
  "hr.value.attendanceTracked": "Tracked",
  "hr.value.attendanceExempt": "Not tracked",
  "hr.tiles.current": "On the team",
  "hr.tiles.currentCaption": "Working here today",
  "hr.tiles.upcoming": "Joining soon",
  "hr.tiles.upcomingCaption": "Start date still ahead",
  "hr.tiles.noRecord": "Without a record",
  "hr.tiles.noRecordCaption": "Open one to track their employment",
  "hr.tiles.noRecordDone": "Everyone has a record",
  "hr.tiles.former": "Former",
  "hr.tiles.formerCaption": "Left or deactivated",
  "hr.tiles.none": "None",
  "hr.directory.filterLabel": "Filter by status",
  "hr.directory.filter.current": "Current",
  "hr.directory.filter.upcoming": "Joining soon",
  "hr.directory.filter.former": "Former",
  "hr.directory.filter.no_record": "No record",
  "hr.directory.filter.all": "All",
  "hr.directory.departmentLabel": "Filter by department",
  "hr.directory.allDepartments": "All departments",
  "hr.directory.search": "Search the directory",
  "hr.directory.caption": "Team directory",
  "hr.directory.columns.person": "Person",
  "hr.directory.columns.department": "Department",
  "hr.directory.columns.manager": "Manager",
  "hr.directory.columns.code": "Code",
  "hr.directory.columns.status": "Status",
  "hr.directory.columns.contract": "Contract",
  "hr.directory.columns.hireDate": "Hire date",
  "hr.directory.openRecord": "Open record",
  "hr.directory.openRecordFor": "Open a record for {name}",
  "hr.directory.noRecordOpen": "No record · open one",
  "hr.directory.loadError": "We could not load the directory.",
  "hr.directory.empty.title": "Nobody here yet",
  "hr.directory.empty.body": "People appear here once they join the team.",
  "hr.directory.noResults.title": "No one matches",
  "hr.directory.noResults.body": "Try another name, status or department.",
  "hr.directory.noResults.clear": "Clear filters",
  "hr.create.title": "Open an employee record",
  "hr.create.description": "Start with the essentials. You can add contacts, identity and insurance details from their profile.",
  "hr.create.step.person": "Who is it for?",
  "hr.create.step.employment": "Employment",
  "hr.create.step.work": "How they work",
  "hr.create.person": "Team member",
  "hr.create.personPlaceholder": "Choose someone without a record",
  "hr.create.personSearch": "Search the team",
  "hr.create.everyoneRecorded": "Everyone on the team already has a record.",
  "hr.create.codeHint": "The next code in sequence. Change it if you use another.",
  "hr.create.submit": "Open record",
  "hr.create.submitting": "Opening…",
  "hr.create.created": "Record opened for {name}.",
  "hr.create.errors.person": "Choose who the record is for.",
  "hr.form.code": "Employee code",
  "hr.form.hireDate": "Hire date",
  "hr.form.probationEnd": "Probation ends",
  "hr.form.endDate": "Last working day",
  "hr.form.endDateHint": "Only when they are leaving or have left.",
  "hr.form.contractType": "Contract",
  "hr.form.contractEnd": "Contract ends",
  "hr.form.manager": "Manager",
  "hr.form.managerNone": "No manager",
  "hr.form.managerSearch": "Search for a manager",
  "hr.form.peopleEmpty": "No one matches.",
  "hr.form.departmentNone": "No department",
  "hr.form.workMode": "Work mode",
  "hr.form.hoursPolicy": "Working hours",
  "hr.form.dailyHours": "Daily hours",
  "hr.form.dailyHoursHint": "Leave empty for the standard workday. Part-time? Enter their hours, such as 6 or 4:30.",
  "hr.form.dailyHoursPlaceholder": "Standard",
  "hr.form.hoursUnit": "hours",
  "hr.form.attendance": "Attendance",
  "hr.form.attendanceRequired": "Track their attendance",
  "hr.form.attendanceRequiredHint": "They clock in and out, and their days count toward attendance.",
  "hr.form.deviceId": "Fingerprint ID",
  "hr.form.deviceIdHint": "Their number on the office fingerprint device.",
  "hr.form.workEmail": "Work email",
  "hr.form.workPhone": "Work phone",
  "hr.form.personalPhone": "Personal phone",
  "hr.form.personalEmail": "Personal email",
  "hr.form.phoneHint": "Such as 010 0123 4567.",
  "hr.form.address": "Home address",
  "hr.form.birthDate": "Date of birth",
  "hr.form.emergencyName": "Contact name",
  "hr.form.emergencyRelation": "Relationship",
  "hr.form.emergencyRelationPlaceholder": "Such as spouse or brother",
  "hr.form.emergencyPhone": "Contact phone",
  "hr.form.nationalId": "National ID",
  "hr.form.socialInsurance": "Social insurance no.",
  "hr.form.insurer": "Insurer",
  "hr.form.policyNumber": "Policy number",
  "hr.form.dependents": "Dependents covered",
  "hr.form.gender": "Gender",
  "hr.form.genderUnset": "Not recorded",
  "hr.form.genderMale": "Male",
  "hr.form.genderFemale": "Female",
  "hr.form.priorService": "Verified prior service (months)",
  "hr.form.priorServiceHint": "Service with earlier employers, once checked. It counts toward the 30-day tier after 10 years.",
  "hr.form.disability": "Has a disability",
  "hr.form.disabilityHint": "45 days of annual leave a year (Art. 124).",
  "hr.form.hazardous": "Hazardous or remote work",
  "hr.form.hazardousHint": "7 more days of annual leave a year (Art. 124).",
  "hr.form.errors.priorService": "Enter whole months, up to 600.",
  "hr.form.notes": "Notes",
  "hr.form.errors.code": "Use 2 to 20 letters, digits or dashes.",
  "hr.form.errors.dailyHours": "Enter between 1 and 12 hours, such as 8 or 6:30.",
  "hr.form.errors.dependents": "Enter a whole number from 0 to 20.",
  "hr.form.errors.email": "Enter a valid email address.",
  "hr.form.errors.phone": "Enter a phone number, such as 010 0123 4567.",
  "hr.form.errors.tooLong": "This is too long.",
  "hr.errors.notFound": "We could not find this employee record.",
  "hr.errors.exists": "This person already has a record.",
  "hr.errors.codeTaken": "Another employee already has this code.",
  "hr.errors.deviceTaken": "Another employee already uses this fingerprint ID.",
  "hr.errors.managerNotFound": "Choose an active team member as the manager.",
  "hr.errors.managerCycle": "That person reports to them, so they cannot be their manager.",
  "hr.errors.dates": "Check the dates: probation, the contract end and the last day all come on or after the hire date.",
  "hr.errors.jobChangeFuture": "Record a change on or before today.",
  "hr.errors.jobChangeEmpty": "Change at least one thing to record a job change.",
  "hr.errors.documentType": "Attach a PDF, PNG, JPEG or WebP file.",
  "hr.errors.documentSize": "The file is larger than 10 MB.",
  "hr.errors.documentNotFound": "This document no longer exists.",
  "hr.errors.certificationNotFound": "This certification no longer exists.",
  "hr.org.search": "Find someone in the chart",
  "hr.org.matchPosition": "{position} of {total}",
  "hr.org.noMatches": "No matches",
  "hr.org.previousMatch": "Previous match",
  "hr.org.nextMatch": "Next match",
  "hr.org.expandAll": "Expand all",
  "hr.org.collapseAll": "Collapse all",
  "hr.org.showReports": "Show {name}’s {count, plural, one {# report} other {# reports}}",
  "hr.org.hideReports": "Hide {name}’s {count, plural, one {# report} other {# reports}}",
  "hr.org.loadError": "We could not load the org chart.",
  "hr.org.empty.title": "No reporting lines yet",
  "hr.org.empty.body": "Set each person’s manager on their record and the chart draws itself.",
  "hr.profile.loading": "Loading…",
  "hr.profile.edit": "Edit record",
  "hr.profile.backToPeople": "Back to people",
  "hr.profile.loadError": "We could not load this record",
  "hr.profile.missing.title": "No employee record",
  "hr.profile.missing.body": "HR has not opened a record for this person yet, or the link is incomplete.",
  "hr.profile.tabs.label": "Record sections",
  "hr.profile.tabs.overview": "Overview",
  "hr.profile.tabs.timeline": "Timeline",
  "hr.profile.tabs.documents": "Documents",
  "hr.profile.tabs.certifications": "Certifications",
  "hr.facts.label": "Key facts",
  "hr.facts.joinedFor": "Joined {date} · {duration}",
  "hr.facts.joins": "Joins {date}",
  "hr.facts.noHireDate": "No hire date yet",
  "hr.facts.reportsTo": "Reports to {name}",
  "hr.facts.noManager": "No manager",
  "hr.tenure.yearsMonths": "{years, plural, one {# year} other {# years}} {months, plural, one {# month} other {# months}}",
  "hr.tenure.years": "{years, plural, one {# year} other {# years}}",
  "hr.tenure.months": "{months, plural, one {# month} other {# months}}",
  "hr.tenure.new": "new this month",
  "hr.section.employment": "Employment",
  "hr.section.workSetup": "Work setup",
  "hr.section.contact": "Contact",
  "hr.section.emergency": "Emergency contact",
  "hr.section.emergencyEmpty": "No emergency contact recorded yet.",
  "hr.section.identity": "Identity",
  "hr.section.identityEmpty": "No ID numbers recorded yet.",
  "hr.section.insurance": "Medical insurance",
  "hr.section.insuranceEmpty": "No medical insurance on record.",
  "hr.section.leaveFacts": "Leave entitlement",
  "hr.section.leaveFactsHint": "Facts the law ties leave to. Visible to HR only.",
  "hr.section.notes": "HR notes",
  "hr.section.notesHint": "Private to HR. The person never sees them.",
  "hr.section.noNotes": "No notes yet.",
  "hr.section.directReports": "Direct reports",
  "hr.section.noReports": "None",
  "hr.expiry.never": "No expiry",
  "hr.expiry.today": "Expires today",
  "hr.expiry.soon": "Expires in {days, plural, one {# day} other {# days}}",
  "hr.expiry.expired": "Expired {days, plural, one {# day} other {# days}} ago",
  "hr.ends.today": "Ends today",
  "hr.ends.soon": "Ends in {days, plural, one {# day} other {# days}}",
  "hr.ends.ended": "Ended",
  "hr.identity.reveal": "Reveal",
  "hr.identity.hide": "Hide",
  "hr.identity.auditNotice": "Revealing the full numbers is recorded in the activity log. They hide again after {seconds} seconds.",
  "hr.identity.maskedNotice": "Only the last four digits are shown, to keep these numbers private.",
  "hr.edit.title": "Edit employee record",
  "hr.edit.label": "Edit the record of {name}",
  "hr.edit.description": "Only the fields you change are saved. To record a promotion or transfer with a date and a reason, use the Timeline.",
  "hr.edit.employmentHint": "A new manager, contract or last day is also added to the timeline.",
  "hr.edit.identityHint": "These numbers are encrypted. Type a new number only to replace the one on file.",
  "hr.edit.sealedReplace": "On file: ending in {code}. Leave empty to keep it.",
  "hr.edit.sealedEmpty": "Not on file yet.",
  "hr.edit.save": "Save changes",
  "hr.edit.saving": "Saving…",
  "hr.edit.saved": "{name}’s record is saved.",
  "hr.edit.conflict.title": "Someone else saved this record",
  "hr.edit.conflict.body": "Reload to see their changes. What you typed here will be replaced, so note anything you need first.",
  "hr.edit.conflict.reload": "Reload record",
  "hr.timeline.title": "Career timeline",
  "hr.timeline.description": "Every hire, promotion, transfer and contract change, newest first.",
  "hr.timeline.effective": "Effective {date}",
  "hr.timeline.recordedBy": "Recorded by {name} · {when}",
  "hr.timeline.field.title": "Title",
  "hr.timeline.field.department": "Department",
  "hr.timeline.field.manager": "Manager",
  "hr.timeline.field.contract_type": "Contract",
  "hr.timeline.field.role": "Access role",
  "hr.timeline.becomes": "changed to",
  "hr.timeline.cleared": "None",
  "hr.timeline.loadError": "We could not load the timeline.",
  "hr.timeline.empty.title": "No career steps yet",
  "hr.timeline.empty.body": "Promotions, transfers and contract changes appear here once they are recorded.",
  "hr.jobChange.open": "Record a job change",
  "hr.jobChange.title": "Record a job change",
  "hr.jobChange.description": "It applies to {name} now and stays on their timeline with its reason.",
  "hr.jobChange.kind": "What changed?",
  "hr.jobChange.effectiveOn": "Effective date",
  "hr.jobChange.effectiveHint": "Today or earlier.",
  "hr.jobChange.newTitle": "New title",
  "hr.jobChange.newDepartment": "Department",
  "hr.jobChange.newManager": "New manager",
  "hr.jobChange.newContract": "New contract",
  "hr.jobChange.current": "Now: {label}",
  "hr.jobChange.departmentsUnavailable": "You do not have access to the department list.",
  "hr.jobChange.reason": "Reason",
  "hr.jobChange.reasonHint": "Kept on the timeline, for whoever reads it next.",
  "hr.jobChange.submit": "Record change",
  "hr.jobChange.submitting": "Recording…",
  "hr.jobChange.recorded": "Job change recorded for {name}.",
  "hr.jobChange.errors.date": "Choose the date it takes effect.",
  "hr.jobChange.errors.title": "Write the new title.",
  "hr.jobChange.errors.reason": "Write a reason of at least 3 characters.",
  "hr.documents.title": "Documents",
  "hr.documents.description": "Contracts, ID copies and certificates, kept private to HR and the person.",
  "hr.documents.caption": "Employee documents",
  "hr.documents.columns.name": "Document",
  "hr.documents.columns.kind": "Type",
  "hr.documents.columns.expires": "Expires",
  "hr.documents.columns.size": "Size",
  "hr.documents.columns.added": "Added",
  "hr.documents.columns.actions": "Actions",
  "hr.documents.open": "Open {name}",
  "hr.documents.edit": "Edit {name}",
  "hr.documents.remove": "Remove {name}",
  "hr.documents.attention": "{count, plural, one {# document needs} other {# documents need}} attention",
  "hr.documents.attentionBody": "Expired documents, or ones expiring within 30 days, are marked below.",
  "hr.documents.loadError": "We could not load the documents.",
  "hr.documents.empty.title": "No documents yet",
  "hr.documents.empty.body": "Upload {name}’s contract, ID copy and certificates to keep them in one place.",
  "hr.documents.empty.bodyReadOnly": "HR has not added any documents for {name} yet.",
  "hr.documents.upload.open": "Upload",
  "hr.documents.upload.title": "Upload a document",
  "hr.documents.upload.description": "It goes to {name}’s HR folder, which only HR and they can open.",
  "hr.documents.upload.drop": "Drop a file here, or choose one",
  "hr.documents.upload.formats": "PDF, PNG, JPEG or WebP, up to 10 MB",
  "hr.documents.upload.remove": "Choose another file",
  "hr.documents.upload.required": "Choose a file to upload.",
  "hr.documents.upload.submit": "Upload",
  "hr.documents.upload.sending": "Uploading…",
  "hr.documents.uploaded": "{name} uploaded.",
  "hr.documents.kind": "Type",
  "hr.documents.name": "Name",
  "hr.documents.expiresOn": "Expiry date",
  "hr.documents.expiresHint": "We flag it 30 days before.",
  "hr.documents.editTitle": "Edit document",
  "hr.documents.save": "Save",
  "hr.documents.saved": "{name} saved.",
  "hr.documents.errors.name": "Write a name.",
  "hr.documents.removeConfirm.title": "Remove {name}?",
  "hr.documents.removeConfirm.body": "The file is deleted for good. Certifications linked to it keep their details.",
  "hr.documents.removeConfirm.confirm": "Remove document",
  "hr.documents.removeConfirm.removing": "Removing…",
  "hr.documents.removed": "{name} removed.",
  "hr.certifications.title": "Certifications",
  "hr.certifications.description": "Professional certificates and courses, with when they expire.",
  "hr.certifications.open": "Add certification",
  "hr.certifications.loadError": "We could not load the certifications.",
  "hr.certifications.empty.title": "No certifications yet",
  "hr.certifications.empty.body": "Add certificates and courses to see what the team is qualified for, and when to renew.",
  "hr.certifications.addTitle": "Add a certification",
  "hr.certifications.editTitle": "Edit certification",
  "hr.certifications.name": "Name",
  "hr.certifications.namePlaceholder": "Such as Google Ads Search",
  "hr.certifications.issuer": "Issued by",
  "hr.certifications.issuedOn": "Issued",
  "hr.certifications.expiresOn": "Expires",
  "hr.certifications.document": "Certificate file",
  "hr.certifications.documentHint": "Link a file from their documents.",
  "hr.certifications.noDocument": "No file",
  "hr.certifications.add": "Add",
  "hr.certifications.save": "Save",
  "hr.certifications.added": "{name} added.",
  "hr.certifications.saved": "{name} saved.",
  "hr.certifications.edit": "Edit {name}",
  "hr.certifications.remove": "Remove {name}",
  "hr.certifications.removed": "{name} removed.",
  "hr.certifications.removeConfirm.title": "Remove {name}?",
  "hr.certifications.removeConfirm.body": "The certification leaves the record. A linked file stays in the documents.",
  "hr.certifications.removeConfirm.confirm": "Remove certification",
  "hr.certifications.errors.name": "Write the certification’s name.",
  "hr.certifications.errors.expiry": "The expiry date comes after the issue date.",
  "hr.me.title": "My HR",
  "hr.me.subtitle": "Your employment record at 404 Creative, as HR keeps it.",
  "hr.me.update": "Update my details",
  "hr.me.updateTitle": "Update my details",
  "hr.me.updateDescription": "Keep how to reach you and your emergency contact up to date. HR keeps the rest.",
  "hr.me.reachTitle": "How to reach you",
  "hr.me.reachHint": "Used only when HR needs you outside work.",
  "hr.me.emergencyHint": "Whom we call if something happens to you at work.",
  "hr.me.save": "Save my details",
  "hr.me.saved": "Your details are saved.",
  "hr.me.loadError": "We could not load your record.",
  "hr.me.empty.title": "Your HR record isn’t open yet",
  "hr.me.empty.body": "HR opens a record for everyone on the team. Once yours is ready, your job details, contacts and documents appear here.",
  "hr.me.documentsTitle": "My documents",
  "hr.me.documentsHint": "Files HR keeps for you. Ask HR to add or replace one.",
  "hr.me.documentsEmpty": "No documents yet.",
  "hr.tabs.attendance": "Attendance",
  "hr.tabs.timeOff": "Time off",
  "hr.tabs.lifecycle": "Joiners & leavers",
  "hr.tabs.assets": "Assets",
  "hr.tabs.letters": "Letters",
  "hr.profile.tabs.attendance": "Attendance",
  "hr.profile.tabs.timeOff": "Time off",
  "hr.profile.tabs.pay": "Pay",
  "hr.profile.tabs.lifecycle": "Checklists & assets",
  "hr.me.tabs.label": "My HR sections",
  "hr.me.tabs.overview": "Overview",
  "hr.me.tabs.attendance": "Attendance",
  "hr.me.tabs.timeOff": "Time off",
  "hr.me.tabs.pay": "Pay",
  "hr.me.tabs.letters": "Letters & assets",
  "hr.nav.requests": "Requests",
  "hr.nav.payroll": "Payroll",
  "hr.me.tabs.growth": "Growth",
  "hr.tabs.performance": "Performance",
  "hr.nav.hiring": "Hiring",
  "hr.tabs.engagement": "Engagement",
  "hr.tabs.reports": "Reports",
  "hr.nav.company": "Company",
  "hr.tabs.settings": "Settings",
  "hr.accommodations.title": "Shorter hours",
  "hr.accommodations.description": "Fewer required minutes a day for a while. HR only; why each was granted stays in the history.",
  "hr.accommodations.lawTitle": "What the law says",
  "hr.accommodations.law.pregnancy": "Pregnancy: at least an hour less a day from the sixth month (Art. 54).",
  "hr.accommodations.law.nursing": "Nursing: an hour a day, or two half hours, for two years after a birth. It counts as work (Art. 56).",
  "hr.accommodations.law.medical": "Medical: shorter days a doctor asked for. Keep the details in the history, not here.",
  "hr.accommodations.law.other": "Any other arrangement HR agreed to.",
  "hr.accommodations.law.overtime": "While pregnancy or nursing time covers a day, overtime can't be requested, until six months after the birth.",
  "hr.accommodations.empty": "No shorter hours on record.",
  "hr.accommodations.loadError": "We couldn't load the shorter hours.",
  "hr.accommodations.add": "Add",
  "hr.accommodations.addTitle": "Add shorter hours",
  "hr.accommodations.editTitle": "Change shorter hours",
  "hr.accommodations.save": "Save",
  "hr.accommodations.added": "Shorter hours added.",
  "hr.accommodations.saved": "Shorter hours saved.",
  "hr.accommodations.edit": "Change {label}",
  "hr.accommodations.remove": "Remove {label}",
  "hr.accommodations.removeTitle": "Remove these shorter hours?",
  "hr.accommodations.removeBody": "The days it covered go back to full hours. Days in a closed month stay as they are.",
  "hr.accommodations.removeConfirm": "Remove",
  "hr.accommodations.removed": "Shorter hours removed.",
  "hr.accommodations.kind": "Kind",
  "hr.accommodations.kinds.pregnancy": "Pregnancy",
  "hr.accommodations.kinds.nursing": "Nursing",
  "hr.accommodations.kinds.medical": "Medical",
  "hr.accommodations.kinds.other": "Other",
  "hr.accommodations.state.current": "Now",
  "hr.accommodations.state.upcoming": "Upcoming",
  "hr.accommodations.state.ended": "Ended",
  "hr.accommodations.summary": "{minutes, plural, one {# minute} other {# minutes}} less a day · {start} – {end}",
  "hr.accommodations.startsOn": "From",
  "hr.accommodations.birthDate": "Birth date",
  "hr.accommodations.endsOn": "Until",
  "hr.accommodations.minutesPerDay": "Minutes less a day",
  "hr.accommodations.minutesHint.pregnancy": "At least 60 by law.",
  "hr.accommodations.minutesHint.nursing": "60 by law: an hour, or two half hours.",
  "hr.accommodations.minutesHint.medical": "As the doctor asked.",
  "hr.accommodations.minutesHint.other": "As agreed.",
  "hr.accommodations.reason": "Reason",
  "hr.accommodations.reasonHint": "Kept in the history; it never shows on the profile.",
  "hr.accommodations.errors.startsOn": "Choose the first day.",
  "hr.accommodations.errors.endsOn": "Choose the last day.",
  "hr.accommodations.errors.endsBeforeStart": "The last day can't be before the first.",
  "hr.accommodations.errors.minutes": "Enter whole minutes from 1 to 480.",
  "hr.accommodations.errors.reason": "Say why, in a few words.",
  "hr.accommodations.errors.gone": "These shorter hours were already removed."
}
